// Centralized image constants (non-local fallbacks and wallpapers)
// Note: DEFAULT_COVER is defined in '@/constants/media' and should be the single source of truth
export const REMOTE_FALLBACK_COVER_URL = 'https://images.pexels.com/photos/3184291/pexels-photo-3184291.jpeg?auto=compress&cs=tinysrgb&w=1200&h=400&fit=crop';
// Default wallpaper used behind public cards when none provided
export const DEFAULT_WALLPAPER_URL = 'https://images.pexels.com/photos/3130320/pexels-photo-3130320.jpeg?auto=compress&cs=tinysrgb&w=1920&h=1080&fit=crop';
